const initialState = { registersData: [], registerData: [], registerFee: [], registerTickets: [], filteredData: [], edited: false, registerID: null, cloneRegister: false, isExist: false, registerModified: false, ticketStatus : false, ticketResponse: [], transactionResponse: [], feeDetails: null };

export const REGISTERREDUCER = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_REGISTERS':
            return {
                ...state,
                registersData: action.data,
                registerData: state.registerData
            }
        case 'GET_REGISTER_DATA':
            return {
                ...state,
                registerData: action.data,
                registersData: state.registersData
            }
        case 'GET_REGISTER_FEE':
            return {
                ...state,
                registerFee: action.data
            }
        case 'FILTER_REGISTERS':
            return {
                ...state,
                registersData: state.registersData,
                filteredData: action.data
            }
        case 'SET_EDIT':
            return {
                ...state,
                edited: action.data
            }
        case 'SET_REGISTER_ID':
            return {
                ...state,
                registerID: action.data
            }
        case 'SET_EXIST':
            return {
                ...state,
                isExist: action.data
            }
        case 'SET_MODIFIED_REGISTER':
            return {
                ...state,
                registerModified: action.data
            }
        case 'SET_CLONE_REGISTER':
            return {
                ...state,
                cloneRegister: action.data
            }
        case 'SET_REGISTER_TICKETS':
            return {
                ...state,
                registerTickets: action.data
            }
        case 'SET_TICKET_STATUS':
            return{
                ...state,
                ticketStatus: action.data
            }   
        case 'SET_TICKET_RESPONSE':
            return {
                ...state,
                ticketResponse: action.data
            }
        case 'SET_TRANSACTION_RESPONSE':
            return {
                ...state,
                transactionResponse: action.data
            }
        case 'SET_FEE_DETAILS':
            return {
                ...state,
                feeDetails: action.data
            }
        default:
            return state;
    }
}